module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-footer": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.target.name) + " was shot by " + _vm._s(_vm.president.name))]), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    staticClass: "art"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2671686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/events/events/assassination/details.vue
// module id = 346
// module chunks = 0